import React, { CSSProperties } from 'react';

const SPINNER_PRIMARY_URL = 'https://assets.urbansitter.com/static/img/logos/spinner-primary.svg';
const SPINNER_WHITE_URL = 'https://assets.urbansitter.com/static/img/logos/spinner-white.svg';

interface Props {
  style?: CSSProperties;
}

const defaultStyles: CSSProperties = {
  display: 'inline-block',
  height: 22,
  marginBottom: -7,
  width: 22,
};

const LogoSpinner = ({ style }: Props): JSX.Element => {
  const styles = { ...defaultStyles, ...style };

  return (
    <div>
      <object
        aria-label='UrbanSitter logo'
        type='image/svg+xml'
        data={styles.color === 'white' ? SPINNER_WHITE_URL : SPINNER_PRIMARY_URL}
        style={styles}
      />
    </div>
  );
}

export { LogoSpinner };
